<template>
    <div id="myAccount">
        <el-table :data="tableData" border>
            <el-table-column prop="typeName" label="账户类型"></el-table-column>
            <el-table-column prop="balanceRmb" label="账户余额（元）"></el-table-column>
            <el-table-column prop="totalHistoryRmb" label="账户总金额（元）"></el-table-column>
              <el-table-column prop="useData" label="账户使用金额（元）"></el-table-column>
            <el-table-column prop="createTime" label="创建时间"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="getAccountDataHandler(scope.row)">查看记录</el-button>
                     <!-- <el-button type="text" size="small" @click="exportAdminSimInfoHandle(scope.row)">导出记录</el-button> -->
                    <!-- <el-button type="text" size="small" v-if="scope.row.type == 10 && isCollect=='1' " @click="applyVisible = true" >申请提现</el-button> -->
                </template>
            </el-table-column>
        </el-table>  

        <div v-if="showAccount">
            <h3>{{ currentAccount }} - 交易流水</h3>
               <el-form :inline="true" ref="searchForm" :model="searchForm" class="forTbFilter">
                   <el-form-item label="时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
              <el-form-item class="btnArea">
                <el-button type="primary" @click="getAccountDataHandlerlist()"><i class="fa fa-search"></i> 查询</el-button>
                <el-button type="success" @click="exportAdminSimInfoHandle()">导出Excel</el-button>
            </el-form-item>
               </el-form>
            <el-table :data="tbpg.tableData" border  >
                <el-table-column prop="accountBalanceRmb" label="账户余额（元）"></el-table-column>
                <el-table-column prop="amountRmb" label="交易金额（元）"></el-table-column>
                <el-table-column prop="createTime" label="交易时间"></el-table-column>
                <el-table-column prop="ioTypeName" label="类型"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="tbpg.currentPage"
                :page-sizes="[15, 50, 100, 500]"
                :page-size="tbpg.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tbpg.total">
            </el-pagination>  
        </div>

        <el-dialog :append-to-body="true"  title="提现申请" :visible.sync="applyVisible"  width="500px" @close="cancelToApply()" :close-on-click-modal="false">

            <el-form  ref="withdrawalForm" :model="withdrawalForm" label-width="100px" label-position="left" >
                <el-form-item label="收款账户：" >
                    <el-select v-model="withdrawalForm.withdrawalId" placeholder="请选择收款账户">
                        <el-option
                          v-for="item in withdrawalOptions"
                          :key="item.id"
                          :label="item.cashType==1?'支付宝 - '+item.payeeAccount:'银行卡 - '+item.payeeAccount"
                          :value="item.id">
                        </el-option>
                    </el-select> 
                </el-form-item>

                <el-form-item style="margin-top: 25px;" label="提现金额：" >
                    <el-input placeholder="请输入提现金额" v-model="input1" v-model.trim="withdrawalForm.priceRmb" @keyup="formatPrice()" 
                        @blur="formatPrice()">
                        <template slot="prepend">￥</template>
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>

                <el-form-item style="margin-top: 25px;" label="提现密码：" >
                    <el-input placeholder="请输入密码" v-model="withdrawalForm.paypass" show-password></el-input>
                </el-form-item>

            </el-form>

            <p style="margin-top: 10px; margin-bottom: 50px;color: #606266;">
            最小提现金额{{cashoutMinAmount}}元，单笔手续费{{cashoutFee}}元</p>
            <el-button @click="withdrawalForm.priceRmb = allBalanceRmb">全部提现</el-button>
            <el-button @click="cancelToApply()">取 消</el-button>
            <el-button type="primary" @click="applyCashOutHandler()">申 请</el-button>
        </el-dialog> 

    </div>
</template>
<script>
import {getAgentAccount, getAccountData} from '@/api/home.js'
import {applyCashOut } from '@/api/finance.js';
import common from '@/utils/common.js'
import {mapGetters } from "vuex";
export default {
    data(){
        return {
            searchForm:{
                time:null
            },
            tableData: [],
            showAccount: false,            
            currentId: '',
            currentAccount: '',
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },

            allBalanceRmb: 0,

            applyVisible: false,
            withdrawalOptions: [],
            withdrawalForm:{
                withdrawalId: null,
                priceRmb: '',
                paypass:null,
            },
            
            cashoutMinAmount: 0,
            cashoutFee: 0,
            isCollect:'0'//是否自收款代理商  1是0否
        }
    },
    methods: {
        exportAdminSimInfoHandle(){//导出excel文件
            var data ={};
            data.token = localStorage.getItem('token');
            data.pageSize = 10000;
            data.prePageNum = 10000;
           // this.exportExcel('/excels/admin/sim/all', data);
             common.sysRequest('excels/agent/account/all', this.searchForm, 'post').then(res => {
                if(res.data.code == 200){
                    this.$message.success('下载中，请稍后在下载管理中查询');
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        getAgentAccountHandler(){
            getAgentAccount({}).then(res => {
                if(res.data.code == 200){
                    this.tableData = res.data.data.resultList;

                    for(let i=0; i<res.data.data.resultList.length; i++){
                        if(res.data.data.resultList[i].type==10){
                            this.allBalanceRmb = res.data.data.resultList[i].balanceRmb;
                        }
                    }

                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        getAccountDataHandlerlist(){
            if(this.currentId==''){
                 this.$message.error('请重新登录');
                return;
            }
            var data = {
                perPageNum: this.tbpg.pageSize,
                pageNo: this.tbpg.currentPage,
                accountId: this.currentId ,
                time:this.searchForm.time             
            }
            getAccountData(data).then(res => {
                this.showAccount = true;
                common.listCallback(this, res, 'tbpg');
            })

        },
        getAccountDataHandler(row){
            if(row){
                this.currentId = row.id;
                this.currentAccount = row.typeName;
                this.tbpg.currentPage = 1;
            }
            var data = {
                perPageNum: this.tbpg.pageSize,
                pageNo: this.tbpg.currentPage,
                accountId: this.currentId              
            }
            getAccountData(data).then(res => {
                this.showAccount = true;
                common.listCallback(this, res, 'tbpg');
            })
        },

        applyCashOutHandler(){
            if(Number(this.withdrawalForm.priceRmb) <= 0){
                this.$message.error('请输入提现金额');
                return;
            }
            let data = {"priceRmb":Number(this.withdrawalForm.priceRmb),
                        "withdrawalId": this.withdrawalForm.withdrawalId,
                        "paypass": this.withdrawalForm.paypass};

            this.$confirm('确定要提现吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                applyCashOut(data).then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getAgentAccountHandler();
                        this.cancelToApply();
                    }else{
                        this.$message.error(res.data.message);
                    }
                    
                })
            }).catch(() => {

            });
        },

        formatPrice(){
            this.withdrawalForm.priceRmb = this.withdrawalForm.priceRmb.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
        },
        cancelToApply(){
            this.withdrawalForm.priceRmb = '';
            this.withdrawalForm.paypass = "";
            this.applyVisible = false;
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAccountDataHandler();
        },
        handleCurrentChange(val){            
            this.tbpg.currentPage = val;
            this.getAccountDataHandler();
        }
    },
    created(){
        this.getAgentAccountHandler();

        // common.sysRequest('agent/account/cashout/config', null, 'post').then(res => {
        //     if(res.data.code == 200){
        //         this.cashoutMinAmount = res.data.data.cashoutMinAmount;
        //         this.cashoutFee = res.data.data.cashoutFee;
        //     }
        // });

        // //获取提现方式及收款账户
        // common.sysRequest('agent/withdrawal/list', {}, 'post').then(res => {  
        //     if(res.data.code == 200){
        //         this.withdrawalOptions = res.data.data.filter(function(item){
        //             if(item.enable){
        //                 return item;
        //             }
        //         });
        //     }
        // });
    },

    mounted(){
        this.isCollect = sessionStorage.getItem('isCollect');
    }

}
</script>
<style lang="less" scoped>
#myAccount {
    h3 {
        font-size: 13px;
        font-weight: bold;
        padding-left: 5px;
        margin: 20px 0;
        border-left: 3px solid #409eff;
    }

    .withdrawalForm{
        margin-bottom: 30px;
    }
}


</style>
